import React from "react";
import PropTypes from "prop-types";
import { t } from '../../../../helpers/translator';

const LiveCasinoGame = ({ game, openGame }) => (
    <div className="single-casino-game-view" key={game.id || game.front_game_id} onClick={openGame(game)}>
        <div className="casino-game-info-view">
            <span className="game-screen-view">
                <img src={game.icon_1 || game.icon_2 || game.icon_3} alt="" />
            </span>
            <p className="casino-game-title">
                <b>{t(game.name)}</b>
            </p>
        </div>
    </div>
);

LiveCasinoGame.propTypes = {
    game: PropTypes.object.isRequired,
    openGame: PropTypes.func.isRequired,
};

export default LiveCasinoGame;